import { useUnsavedReportContext } from "../../contexts/UnsavedReportContext.ts";
import type { EditorProps } from "../viewer/common/Types.ts";
import ReportTypeSelector from "./ReportTypeSelector.tsx";
import type { Report } from "../../../../../../api/types/svTypes.ts";

interface Props {
  Editor: React.ComponentType<EditorProps>;
  report: Report;
}
const ReportEditor = ({ Editor, report }: Props) => {
  const unsavedReport = useUnsavedReportContext();
  return <Editor ReportTypeSelector={unsavedReport ? null : <ReportTypeSelector report={report} />} />;
};

export default ReportEditor;
